export enum NavigationType {
    None = 0,
    List = 1,
    Map = 2
}
